/**
 * Tab간 sessionStorage 동기화 처리기
 * @author pat
 */
class SessionStorageSynchonizer {
    static #eventListener(event) {
        if (!event) {
            event = window.event;
        }
        if (!event || event.storageArea != localStorage) {
            return;
        }
        if (event.key == '_SSSync.req') {
            if (event.newValue) {
                const req = JSON.parse(event.newValue);
                switch(req.type) {
                    case 'all':
                        if (sessionStorage.length != 0) {
                            localStorage.setItem('_SSSync.res', JSON.stringify(sessionStorage));
                            localStorage.removeItem('_SSSync.res');
                        }
                        break;
                    case 'clear':
                        sessionStorage.clear();
                        break;
                    case 'item':
                        if (req.data != null) {
                            sessionStorage.setItem(req.key, req.data);
                        } else {
                            sessionStorage.removeItem(req.key);
                        }
                        break;
                }
            }
        } else if (event.key == '_SSSync.res') {
            if (event.newValue) {
                if (sessionStorage.length == 0) {
                    const syncItems = JSON.parse(event.newValue);
                    for (let itemKey in syncItems) {
                        sessionStorage.setItem(itemKey, syncItems[itemKey]);
                    }
                }

                window.dispatchEvent(new Event('session-storage-synced'));
            }
        }
    }
    static init() {
        if (typeof window.addEventListener == 'function') {
            window.removeEventListener('storage', this.#eventListener);
            window.addEventListener('storage', this.#eventListener);
        } else {
            window.onstorage = sessionStorageSyncListener;
        }
        localStorage.setItem('_SSSync.req', JSON.stringify({type: 'all'}));
        localStorage.removeItem('_SSSync.req');
    }
    static clear() {
        sessionStorage.clear();
        localStorage.setItem('_SSSync.req', JSON.stringify({type: 'clear'}));
        localStorage.removeItem('_SSSync.req');
    }
    static getItem(key) {
        return sessionStorage.getItem(key);
    }
    static setItem(key, value) {
        if (value == null) {
            this.removeItem(key);
        }
        sessionStorage.setItem(key, value);
        localStorage.setItem('_SSSync.req', JSON.stringify({type: 'item', key: key, data: value}));
        localStorage.removeItem('_SSSync.req');
    }
    static removeItem(key) {
        sessionStorage.removeItem(key);
        localStorage.setItem('_SSSync.req', JSON.stringify({type: 'item', key: key, data: null}));
        localStorage.removeItem('_SSSync.req');
    }
}

export default SessionStorageSynchonizer;